// The age floor for the primary owner on the signup Personal Info step.
//
// KYC at both bank partners requires an adult account holder, so an under-age
// date of birth used to clear this form and surface in underwriting instead of
// at the field where it was typed. Bounds and copy live here — shared by the
// component, the validator and their tests — so the rule is stated in exactly
// one place.

/** Minimum age a primary owner may declare and still continue signup. */
export const MINIMUM_AGE_YEARS = 18;

/**
 * Sanity upper bound on age. Catches a mistyped year (1906 for 1996) that clears
 * every other rule.
 */
export const MAXIMUM_AGE_YEARS = 120;

/**
 * Validation copy for the date-of-birth field. `underage` names the 18 rule
 * outright — the customer needs to know why they are blocked, not just that they
 * are.
 */
export const DATE_OF_BIRTH_MESSAGES = {
  required: 'Date of birth is required',
  invalid: 'Please enter a valid date of birth',
  future: 'Date of birth cannot be in the future',
  underage: `You must be at least ${MINIMUM_AGE_YEARS} years old to open a TACH account`,
  implausible: 'Please check the year of birth',
};
